export default __webpack_public_path__ + "static/media/Resume.aaa7b91f.pdf";